// vue
import { ref, computed, watch, onMounted } from 'vue';

// services
import StatsService from '@services/statsService';

// i18n
import { useI18n } from 'vue-i18n';

// store
import { useGl } from '@store/ts/gl';
import { useRefs } from '@store/ts/refs';
import { useStats } from '@store/stats';

// router
import { useRoute, useRouter } from 'vue-router';

export default function () {
    const route = useRoute();
    const router = useRouter();

    // store
    const gl = useGl();
    const refs = useRefs();
    const stats = useStats();

    // i18n
    const { t } = useI18n();

    const init = ref(false);

    const currentTab = computed(() => {
        if (route.name.includes('trade-statistic.main')) {
            return 'bots_and_dates'; 
        } else {
            return 'transactions'; 
        }
    });

    const loading = computed(() => gl.loading);

    const showTabs = computed(() => route.name !== 'trade-statistic.management');

    const tabs = computed(() => !init.value
        ? []
        : [
            {
                name: 'bots_and_dates',
                routeName: 'trade-statistic.main',
                title: stats.localization?.bots_and_dates || 'Боты и даты',
            }, {
                name: 'transactions',
                routeName: 'trade-statistic.transactions',
                title: stats.localization?.transactions || 'Транзакции',
            },
        ]);
        
    const changeTab = tab => {
        const el = tabs.value.find(el => el?.name == tab);

        if (el) {
            router.push({ name: el.routeName });
            currentTab.value = tab;
        }
    };

    const getData = async () => {
        try {
            if (!stats.refs) {
                gl.showLoading = true;

                stats.refs = await StatsService.getRefs();
              
                gl.showLoading = false;
            }
        } catch {
            gl.showNotification({
                type: 'error',
                msg: t('errorMessage'),
            });
        };
    };

    onMounted(async () => {
        await getData();

        init.value = true;
    });

    return {
        tabs,
        init,
        loading,
        showTabs,
        currentTab,
        changeTab,
    };
}